export const ONE_MILLION = 1000000;
export const ONE_BILLION = ONE_MILLION * 1000;
export const ONE_TRILLION = ONE_BILLION * 1000;
export const TEN_MILLION = ONE_MILLION * 10;
export const KWH_UNIT = 'kWh';
export const KWH_DECIMAL_POINT = 1;
export const KW_UNIT = 'kW';
export const KW_DECIMAL_POINT = 2;
export const SQUARE_FEET = 'ft\u{00B2}';
export const SQUARE_METER = 'm\u{00B2}';
export const NUM_FEET_IN_ONE_METER = 3.281;
export const NUM_SQUARE_FEET_IN_ONE_SQUARE_METER = 10.764;
export var TIME_IN_MILLISECONDS;
(function (TIME_IN_MILLISECONDS) {
    TIME_IN_MILLISECONDS[TIME_IN_MILLISECONDS["THIRTY_MINUTES"] = 1800000] = "THIRTY_MINUTES";
    TIME_IN_MILLISECONDS[TIME_IN_MILLISECONDS["TWO_HOURS"] = 7200000] = "TWO_HOURS";
    TIME_IN_MILLISECONDS[TIME_IN_MILLISECONDS["ONE_DAY"] = 86400000] = "ONE_DAY";
    TIME_IN_MILLISECONDS[TIME_IN_MILLISECONDS["FIFTEEN_DAYS"] = 1296000000] = "FIFTEEN_DAYS";
    TIME_IN_MILLISECONDS[TIME_IN_MILLISECONDS["THIRTY_DAYS"] = 2592000000] = "THIRTY_DAYS";
})(TIME_IN_MILLISECONDS || (TIME_IN_MILLISECONDS = {}));
export var WEEKDAYS;
(function (WEEKDAYS) {
    WEEKDAYS[WEEKDAYS["MON"] = 0] = "MON";
    WEEKDAYS[WEEKDAYS["TUE"] = 1] = "TUE";
    WEEKDAYS[WEEKDAYS["WED"] = 2] = "WED";
    WEEKDAYS[WEEKDAYS["THU"] = 3] = "THU";
    WEEKDAYS[WEEKDAYS["FRI"] = 4] = "FRI";
    WEEKDAYS[WEEKDAYS["SAT"] = 5] = "SAT";
    WEEKDAYS[WEEKDAYS["SUN"] = 6] = "SUN";
})(WEEKDAYS || (WEEKDAYS = {}));
export var MONTHS;
(function (MONTHS) {
    MONTHS[MONTHS["January"] = 0] = "January";
    MONTHS[MONTHS["February"] = 1] = "February";
    MONTHS[MONTHS["March"] = 2] = "March";
    MONTHS[MONTHS["April"] = 3] = "April";
    MONTHS[MONTHS["May"] = 4] = "May";
    MONTHS[MONTHS["June"] = 5] = "June";
    MONTHS[MONTHS["July"] = 6] = "July";
    MONTHS[MONTHS["August"] = 7] = "August";
    MONTHS[MONTHS["September"] = 8] = "September";
    MONTHS[MONTHS["October"] = 9] = "October";
    MONTHS[MONTHS["November"] = 10] = "November";
    MONTHS[MONTHS["December"] = 11] = "December";
})(MONTHS || (MONTHS = {}));
